const requireRouter = require.context('.', false, /^(?!\.\/index|\.\/cockpit).*\.js$/)
let routers = [{
  path: '/product/index',
  component: () => import('@/views/feiche/index'),
  name: 'product-index',
  meta: {
    title: ''
  }
}]

requireRouter.keys().forEach(fileName => {
  routers = [...routers, ...requireRouter(fileName).default]
})

export default routers



// WEBPACK FOOTER //
// ./src/router/product/index.js